var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    directives: [{
      name: "lock-scroll",
      rawName: "v-lock-scroll"
    }],
    ref: "indexPageRef",
    staticClass: "index-page page"
  }, [_c('m-head', {
    ref: "mHeadRef"
  }), _c('div', {
    staticClass: "index-bg",
    style: {
      background: `url(${require(`@images/${_vm.aiSkin}/chat-bg.jpg`)}) center/100% auto no-repeat`
    }
  }), _c('div', {
    staticClass: "index-main page-main"
  }, [_c('index-guide', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isGuideTab == 0,
      expression: "isGuideTab == 0"
    }]
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isGuideTab == 1,
      expression: "isGuideTab == 1"
    }],
    ref: "indexBodysRef",
    staticClass: "index-bodys scrollable",
    style: {
      height: _vm.indexBodyHeight <= 0 ? '100%' : _vm.indexBodyHeight
    },
    on: {
      "touchmove": _vm.indexBodyTouchMove,
      "click": _vm.indexBodyTouchMove
    }
  }, [_c('div', {
    staticClass: "index-con"
  }, [_c('div', {
    staticClass: "index-tab"
  }, [_c('div', {
    staticClass: "index-tab-item left",
    class: _vm.isTab == 1 && 'active',
    on: {
      "click": function ($event) {
        return _vm.onTab(1);
      }
    }
  }, [_c('div', {
    staticClass: "index-tab-body"
  }, [_c('div', {
    staticClass: "index-tab-main"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.aiSkin}/tab-icon-2.png`),
      "alt": ""
    }
  }), _vm._v("PAOLO TEXT CHAT")])])]), _c('div', {
    staticClass: "index-tab-item right",
    class: _vm.isTab == 0 && 'active',
    on: {
      "click": function ($event) {
        return _vm.onTab(0);
      }
    }
  }, [_c('div', {
    staticClass: "index-tab-body"
  }, [_c('div', {
    staticClass: "index-tab-main"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.aiSkin}/tab-icon-1.png`),
      "alt": ""
    }
  }), _vm._v("PAOLO VOICE CHAT")])])])]), _c('div', {
    ref: "indexChatsRef",
    staticClass: "index-chats"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isTab == 1,
      expression: "isTab == 1"
    }],
    staticClass: "index-chats-main text"
  }, [_vm.chatInfo.chatList ? [_vm.chatInfo.chatList.length > 0 ? _vm._l(_vm.chatInfo.chatList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "index-chats-item"
    }, [item?.dateTag ? _c('div', {
      staticClass: "index-chats__date"
    }, [_c('span', [_vm._v(_vm._s(item.dateTag))])]) : _vm._e(), item.role === 'assistant' ? _c('div', {
      staticClass: "index-chats-a"
    }, [_c('div', {
      staticClass: "index-chats__head"
    }, [_c('img', {
      attrs: {
        "src": require(`@images/${_vm.aiSkin}/ai.jpg`),
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "index-chats__content",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })]) : item.role === 'user' ? _c('div', {
      staticClass: "index-chats-m"
    }, [_c('div', {
      staticClass: "index-chats__head"
    }, [_vm.userInfo.avatar ? _c('img', {
      attrs: {
        "src": _vm.userInfo.avatar,
        "alt": ""
      }
    }) : _c('m-head-img', {
      attrs: {
        "name": _vm.userInfo,
        "bgColor": _vm.userInfo.head_color
      }
    })], 1), _c('div', {
      staticClass: "index-chats__content",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })]) : _vm._e()]);
  }) : [_c('div', {
    staticClass: "index-chats-greeting"
  }, [_vm._v(" Hello,"), _c('span', [_vm._v(_vm._s(_vm.userInfo.nickname))])])]] : [_vm._m(0)]], 2), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isTab == 0,
      expression: "isTab == 0"
    }],
    staticClass: "index-chats-main voice"
  }, [_vm._m(1)])])])])], 1), _vm.isTab == 1 && _vm.isGuideTab == 1 ? [_c('div', {
    ref: "wrapperRef",
    staticClass: "input-wrapper",
    class: _vm.isMobile && 'wap',
    style: {
      bottom: _vm.deviceType == 'pc' || _vm.isMenuShow ? _vm.remTran(265) + 'rem' : 0
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return (() => {}).apply(null, arguments);
      },
      "touchmove": function ($event) {
        $event.stopPropagation();
        return (() => {}).apply(null, arguments);
      }
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.chatText,
      expression: "chatText"
    }],
    ref: "textareaRef",
    attrs: {
      "rows": _vm.textareaRows,
      "placeholder": "Say anything",
      "enterkeyhint": "send"
    },
    domProps: {
      "value": _vm.chatText
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.chatText = $event.target.value;
      }, _vm.onTextareaInput],
      "focus": _vm.onTextareaFocus,
      "blur": _vm.onTextareaBlur,
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.preventDefault();
        return _vm.onSend.apply(null, arguments);
      }
    }
  }), _vm.deviceType == 'pc' ? _c('div', {
    staticClass: "input-wrapper-confirm",
    on: {
      "click": function ($event) {
        _vm.chatInfo.chatList && !_vm.chatLoading && _vm.onSend();
      }
    }
  }, [_vm.chatInfo.chatList && !_vm.chatLoading ? _c('svg-icon', {
    attrs: {
      "name": "icon-chat"
    }
  }) : _c('div', {
    staticClass: "circleLoading"
  })], 1) : _vm._e()])] : _vm._e(), _vm.deviceType == 'pc' || _vm.isMenuShow ? [_c('m-menu', {
    ref: "mMenuRef"
  })] : _vm._e()], 2);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "index-chats-loading"
  }, [_c('div', {
    staticClass: "mexican-wave"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "index-chats-soon"
  }, [_c('span', [_vm._v("Coming soon")])]);
}];
export { render, staticRenderFns };